import apiService from "./apiService";


class ClientiService {

/**
   * Ottiene la lista degli articoli disponibili
   * @param {string} codiceCliente - Codice del cliente specifico (opzionale, es. '0123')
   * @returns {Promise<Array>} Lista degli articoli
   */
  async getClienti(codiceCliente = null) {
    try {
      const codcliente = codiceCliente || localStorage.getItem("codiceCliente");
      
      // Costruisce l'URL con il parametro opzionale
      let url = `/clienti`;
      
      if (codiceCliente) {
        url += `/${codiceCliente}`;
      }
      const response = await apiService(url, "GET");

      return response.data; 
    } catch (error) {
      console.error(`Errore nel recupero della lista clienti${codiceCliente ? ` per codice ${codiceCliente}` : ''}`, error);
        throw error;
    }
  }

  /**
   * Crea un nuovo cliente
   * @param {Object} clienteData - Dati del nuovo cliente
   * @returns {Promise<Object>} Dati del cliente creato
   */
  async createCliente(clienteData) {
    try {
      console.log('🆕 === CREAZIONE NUOVO CLIENTE ===');
      console.log('📋 Dati cliente ricevuti:', clienteData);

      const {
        c_cliente,
        cliente,
        indirizzo,
        citta,
        prov,
        cap,
        piva,
        cod_fisc,
        tel,
        categ,
        categ2,
        condi_pag,
        email,
        persona,
        cano_sog
      } = clienteData;

      const canoSogValue = Number(cano_sog ?? 1) === 1 ? 1 : 0;

      const bodyData = {
        cliente,
        indirizzo,
        citta,
        prov,
        cap,
        piva,
        cod_fisc,
        tel,
        categ,
        categ2,
        condi_pag,
        email,
        persona,
        cano_sog: canoSogValue
      };

      // Aggiunge c_cliente solo se è definito e non vuoto
      if (c_cliente && c_cliente.trim() !== '') {
        bodyData.c_cliente = c_cliente;
        console.log('📝 Codice cliente specificato:', c_cliente);
      } else {
        console.log('📝 Codice cliente non specificato - verrà generato automaticamente dal server');
      }

      console.log('📦 Body dati preparato:', bodyData);
      console.log('📡 Chiamata PUT /clienti...');

      const response = await apiService('/clienti', 'PUT', bodyData);
      
      console.log('✅ Risposta creazione cliente:', response);

      return response.data;
    } catch (error) {
      console.error('💥 === ERRORE CREAZIONE CLIENTE ===');
      console.error('❌ Errore completo:', error);
      console.error('📜 Stack trace:', error.stack);
      console.error('🌐 Response error:', error.response?.data);
      console.error('📊 Status code:', error.response?.status);
      console.error('📦 Dati che hanno causato errore:', clienteData);
      
      console.error('Errore nella creazione del nuovo cliente:', error);
      throw error;
    }
  }

  /**
   * Aggiorna un cliente esistente
   * @param {string} codiceCliente - Codice del cliente da aggiornare
   * @param {Object} clienteData - Dati del cliente da aggiornare
   * @returns {Promise<Object>} Dati del cliente aggiornato
   */
  async updateCliente(codiceCliente, clienteData) {
    try {
      const {
        cliente,
        indirizzo,
        citta,
        prov,
        cap,
        piva,
        cod_fisc,
        tel,
        categ,
        categ2,
        condi_pag,
        email,
        persona,
        cano_sog
      } = clienteData;

      const canoSogValue = Number(cano_sog ?? 1) === 1 ? 1 : 0;

      const response = await apiService(`/clienti/${codiceCliente}/true`, 'POST', {
        cliente,
        indirizzo,
        citta,
        prov,
        cap,
        piva,
        cod_fisc,
        tel,
        categ,
        categ2,
        condi_pag,
        email,
        persona,
        cano_sog: canoSogValue
      });

      return response.data;
    } catch (error) {
      console.error(`Errore nell'aggiornamento del cliente ${codiceCliente}:`, error);
      throw error;
    }
  }

  /**
   * Cerca destinazioni per email (username)
   * @param {string} email - Email/username da cercare
   * @returns {Promise<Array>} Lista delle destinazioni trovate con quell'email
   */
  async getDestinazioniByEmail(email) {
    try {
      console.log('🔍 === RICERCA DESTINAZIONI PER EMAIL ===');
      console.log('📧 Email cercata:', email);

      // Endpoint per cercare destinazioni per email
      const url = `/destinazioni?destlogin=${encodeURIComponent(email)}`;
      const response = await apiService(url, "GET");
      
      // Ritorna l'array di destinazioni trovate (può essere vuoto)
      return response.data || [];
      
    } catch (error) {
      console.error('❌ Errore nella ricerca destinazioni per email:', error);
      
      // Se l'errore è 404 (non trovato), ritorna array vuoto invece di lanciare errore
      if (error.response && error.response.status === 404) {
        console.log('⚠️ Nessuna destinazione trovata per questa email');
        return [];
      }
      
      throw error;
    }
  }

  /**
   * Salva o aggiorna una destinazione specifica per un cliente
   * @param {string} codiceCliente - Codice del cliente
   * @param {string} codiceDestinazione - Codice della destinazione
   * @param {Object} datiDestinazione - Dati della destinazione da salvare
   * @returns {Promise<Object>} Risposta dal server
   */
  async salvaDestinazione(codiceCliente, codiceDestinazione, datiDestinazione) {
    try {

      console.log('💾 === SALVATAGGIO DESTINAZIONE ===');
      console.log('🏢 Codice Cliente:', codiceCliente);
      console.log('📍 Codice Destinazione:', codiceDestinazione);
      console.log('📋 Dati:', datiDestinazione);

      // Costruisce l'URL per salvare/aggiornare la destinazione
      const url = `/clienti/${codiceCliente}/destinazioni/${codiceDestinazione}`;
      
      // Body con i dati della destinazione
      const body = {
        nomede: datiDestinazione.nomede || '',
        viade: datiDestinazione.viade || '',
        cittade: datiDestinazione.cittade || '',
        provinciade: datiDestinazione.provinciade || '',
        nazionede: datiDestinazione.nazionede || '',
        capde: datiDestinazione.capde || '',
        destlogin: datiDestinazione.destlogin || '',
        destpsw: datiDestinazione.destpsw || '',
        orderactive: datiDestinazione.orderactive || '0',
        lun_act: datiDestinazione.lun_act || '0',
        mar_act: datiDestinazione.mar_act || '0',
        mer_act: datiDestinazione.mer_act || '0',
        gio_act: datiDestinazione.gio_act || '0',
        ven_act: datiDestinazione.ven_act || '0',
        sab_act: datiDestinazione.sab_act || '0',
        dom_act: datiDestinazione.dom_act || '0',
        spec_act: datiDestinazione.spec_act || '0',
        abilita_blocco: String(datiDestinazione.abilita_blocco ?? '0').trim() === '1' ? '1' : '0',
        orarioblocco_dest: datiDestinazione.orarioblocco_dest ?? ''
      };

      console.log('📡 URL chiamata:', url);
      console.log('📦 Body inviato:', body);
      
      // Usa PUT per aggiornare la destinazione esistente
      const response = await apiService(url, 'POST', body);
      
      console.log('✅ Risposta salvataggio destinazione:', response);
      
      return response.data;
    } catch (error) {
      console.error('❌ Errore nel salvataggio della destinazione:', error);
      throw error;
    }
  }

  /**
   * Salva un contatto aggiuntivo per un cliente
   * PUT /api/clienti/{codicecliente}/contatti
   * @param {string} codiceCliente - Codice del cliente
   * @param {Object} contatto - Dati del contatto: persona, ruolo, tel1, tel2, cell, email, predefinito
   * @returns {Promise<Object>} Risposta dal server
   */
  async salvaContattoAggiuntivo(codiceCliente, contatto) {
    try {
      const url = `/clienti/${codiceCliente}/contatti`;
      const body = {
        persona: contatto.persona ?? '',
        ruolo: contatto.ruolo ?? '',
        tel1: contatto.tel1 ?? '',
        tel2: contatto.tel2 ?? '',
        cell: contatto.cell ?? '',
        email: contatto.email ?? '',
        predefinito: contatto.predefinito ? 1 : 0
      };
      const response = await apiService(url, 'PUT', body);
      return response.data;
    } catch (error) {
      console.error(`Errore nel salvataggio contatto aggiuntivo per cliente ${codiceCliente}:`, error);
      throw error;
    }
  }

  /**
   * Modifica un contatto aggiuntivo esistente
   * POST /api/clienti/{codicecliente}/contatti/{codContattoAggiuntivo}
   * @param {string} codiceCliente - Codice del cliente
   * @param {string|number} codContattoAggiuntivo - Id del contatto (id)
   * @param {Object} contatto - Dati del contatto: persona, ruolo, tel1, tel2, cell, email, predefinito
   * @returns {Promise<Object>} Risposta dal server
   */
  async modificaContattoAggiuntivo(codiceCliente, codContattoAggiuntivo, contatto) {
    try {
      const url = `/clienti/${codiceCliente}/contatti/${codContattoAggiuntivo}`;
      const body = {
        persona: contatto.persona ?? '',
        ruolo: contatto.ruolo ?? '',
        tel1: contatto.tel1 ?? '',
        tel2: contatto.tel2 ?? '',
        cell: contatto.cell ?? '',
        email: contatto.email ?? '',
        predefinito: contatto.predefinito ? 1 : 0
      };
      const response = await apiService(url, 'POST', body);
      return response.data;
    } catch (error) {
      console.error(`Errore nella modifica contatto ${codContattoAggiuntivo} per cliente ${codiceCliente}:`, error);
      throw error;
    }
  }

  /**
   * Elimina un contatto aggiuntivo
   * DELETE /api/clienti/{codicecliente}/contatti/{id}
   * @param {string} codiceCliente - Codice del cliente
   * @param {string|number} idContatto - Id del contatto da eliminare
   * @returns {Promise<Object>} Risposta dal server
   */
  async eliminaContattoAggiuntivo(codiceCliente, idContatto) {
    try {
      const url = `/clienti/${codiceCliente}/contatti/${idContatto}`;
      const response = await apiService(url, 'DELETE');
      return response.data;
    } catch (error) {
      console.error(`Errore nell'eliminazione contatto ${idContatto} per cliente ${codiceCliente}:`, error);
      throw error;
    }
  }
}

export default new ClientiService();



